export var MessageSeverity;
(function(MessageSeverity) {
    MessageSeverity["TIP"] = "tip";
    MessageSeverity["INFO"] = "info";
    MessageSeverity["ERROR"] = "error";
    MessageSeverity["SUCCESS"] = "success";
})(MessageSeverity || (MessageSeverity = {}));
export var MessageRole;
(function(MessageRole) {
    MessageRole["STATUS"] = "status";
    MessageRole["ALERT"] = "alert";
})(MessageRole || (MessageRole = {}));
